module.exports = __webpack_public_path__ + "img/icon_status_red_big.4f648977.svg";